export default __webpack_public_path__ + "static/media/mypage_pc.2dd6fe24.jpg";